<template>
    <form-item-wrapper :widget="widget" :formData="formData" ref="itemref">
        <a-switch v-model:checked="formData[widget.name]" :disabled="widget.options.disabled" @change="handleOnChange">
        </a-switch>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs } from 'vue';
import useEvent from "./useEvent";

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)

const {
    handleOnChange,
} = useEvent(widget.value, itemref, formData.value);
</script>